import { PostApi, DeleteApi } from "../../services/ApiService";

export const getUsers = async (setloading, data) => {
  try {
    setloading(true);
    let response = await PostApi(`/user/usersCompleteDetails`, data);
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return "";
  }
};

// Add New user
export const addUser = async (setloading, data) => {
  try {
    setloading(true);
    let response = [];
    response = await PostApi(`/user/addNewUser`, data);
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return [];
  }
};

// deleet inspection by visit Id
export const deleteUser = async (setloading, userId) => {
  try {
    setloading(true);
    let response = [];
    response = await DeleteApi(`/user/${userId}`);
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return [];
  }
};
